import { FirebaseApplicant } from "../../../entities/applicant";
import { Query } from "../../../entities/query";
import ApplicantRepository from "../../ports/applicantRepository";

export type fetchApplicantsListUsecase = (query: Query) => Promise<{
  data?: FirebaseApplicant[];
  lastElement?: unknown;
  firstElement?: unknown;
}>;

export const buildFetchApplicantsList = (dependencies: {
  applicantRepo: ApplicantRepository;
}): fetchApplicantsListUsecase => {
  const { applicantRepo } = dependencies;

  const fetchApplicantsList: fetchApplicantsListUsecase = async (query: Query) => applicantRepo.fetchApplicantsList(query);

  return fetchApplicantsList;
};
